module.exports = __webpack_public_path__ + "ca7cf0d1e18562fe106d0d51beb33b6e.fbx";